export default __webpack_public_path__ + "static/media/power-washing.24d31fd2.svg";